export default __webpack_public_path__ + "static/media/Green_tick.f8977816.png";